import request from '$services/request'

const getInfo = () => {
  return request('/finance-common-operation-ws/api/act/user/v1/queryLoanUserInfo', {}, { loading: false, showError: false })
}

export const SELECT_INVERSE = 'SELECT_'

/**
 * Enum for 用户的贷款中转去向.
 * @readonly
 * @enum {string}
 */
export enum ETransferCode {
  /**
   * @desc 未分配贷款去向 =》 弹窗选择
   */
  SELECT = 'SELECT',
  /**
   * @desc 未分配贷款去向 =》 贷款首页
   */
  MARKET = 'MARKET',
  /**
   * @desc 随心
   */
  SUIXIN = 'SUIXIN',
  /**
   * @desc 随手
   */
  SUISHOU = 'SUISHOU',
  /**
   * @desc 福袋
   */
  FUDAI = 'FUDAI',
  /**
   * @desc 瑞贷
   */
  RUIDAI = 'RUIDAI',
  /**
   * @desc 瑞贷被拒 福袋可选
   */
  SELECT_FUDAI = 'SELECT_FUDAI',
  /**
   * @desc 福袋被拒 瑞贷可选
   */
  SELECT_RUIDAI = 'SELECT_RUIDAI',
}


/**
 * Enum for 用户的贷款状态
 * @readonly
 * @enum {number}
 */
export enum ECreditStatus {
  /**
   * @desc 未授信
   */
  UN_CREDIT = 0,
  /**
   * @desc 授信失败，时效内
   */
  FAIL_IN_LIMIT_TIME = 1,
  /**
   * @desc 授信成功
   */
  CREDIT_SUCCESS = 2,
  /**
   * @desc 授信失败，时效外
   */
  FAIL_OUT_LIMIT_TIME = 3,
}

interface IUserLoanInfo {
  productCode: ETransferCode;
  creditStatus: number;
  nextCreditStatus: number;
}


/** @desc 缓存用户的贷款信息 */
let storageUserLoanInfo: IUserLoanInfo

/**
 * 获取用户的贷款信息
 * @param {boolean} refresh - 是否强制刷新
 * @returns Promise<userLoanInfo>
 * @see {@link http://yapi.sui.work/project/58/interface/api/8459 | YApi}
 */
export const getUserLoanInfo = async(refresh = false) => {
  if (storageUserLoanInfo && !refresh) {
    return Promise.resolve(storageUserLoanInfo)
  }
  return getInfo()
    .then((data) => {
      storageUserLoanInfo = data
      return storageUserLoanInfo
    })
}


/**
 * 转换贷款code
 * @param {object} userLoanInfo
 * @returns {Promise<string>} code in ETransferCode
 */
const handleLoanInfo2TransferCode = (userLoanInfo: IUserLoanInfo): ETransferCode => {
  const { productCode, creditStatus, nextCreditStatus } = userLoanInfo

  let transferCode: ETransferCode = productCode

  const safeCode = [ETransferCode.FUDAI, ETransferCode.RUIDAI]

  // 保护层，如果不是福袋，瑞贷的产品，直接返回
  if (!safeCode.includes(transferCode)) {
    if (!Object.keys(ETransferCode).includes(transferCode)) {
      transferCode = ETransferCode.SELECT
    }
    return transferCode
  }

  switch (creditStatus) {
    case ECreditStatus.UN_CREDIT:
      // 信任后端返回
      break
    case ECreditStatus.FAIL_IN_LIMIT_TIME:
      if (nextCreditStatus === ECreditStatus.FAIL_IN_LIMIT_TIME) {
        // 两个产品都是授信失败，且都在限制时间内
        transferCode = ETransferCode.MARKET
      } else {
        // 自己在受限时间外，对立未授信或者授信成功，引导去对立的
        const index = safeCode.indexOf(transferCode)
        transferCode = <ETransferCode>(SELECT_INVERSE + safeCode[+!index])
      }
      break
    case ECreditStatus.CREDIT_SUCCESS:
      // 信任后端返回
      break
    case ECreditStatus.FAIL_OUT_LIMIT_TIME:
      if (nextCreditStatus === ECreditStatus.FAIL_OUT_LIMIT_TIME) {
        // 两个产品都是授信失败，且都在限制时间外
        transferCode = ETransferCode.SELECT
      } else if (nextCreditStatus === ECreditStatus.FAIL_IN_LIMIT_TIME) {
        transferCode = <ETransferCode>(SELECT_INVERSE + transferCode)
      } else {
        // 自己在受限时间外，对立未授信或者授信成功，引导去对立的
        const index = safeCode.indexOf(transferCode)
        transferCode = <ETransferCode>(SELECT_INVERSE + safeCode[+!index])
      }
      break
    default:
      // 信任后端返回
      break
  }

  return transferCode
}

/** @desc 缓存用户的贷款信息 */
let storageUserTransferCode: ETransferCode

/**
 * 获取用户的贷款中转code
 * @param {boolean} refresh - 是否强制刷新
 * @returns {Promise<string>} code in ETransferCode
 */
const getTransferCode = async(refresh = false) => {
  if (storageUserTransferCode && !refresh) {
    return Promise.resolve(storageUserTransferCode)
  }
  try {
    const userLoanInfo = await getUserLoanInfo(refresh)
    storageUserTransferCode = handleLoanInfo2TransferCode(userLoanInfo)
    return Promise.resolve(storageUserTransferCode)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default getTransferCode
